import React from 'react';
import Select from 'react-select';

const BrandSelect = ({ brandsList, value, onChange }) => {
  const brandOptions = brandsList.map(b => ({
    value: `https://cdn.anubesport.com/timing/vehicle-logos/car/${b.image}.car.png`,
    label: b.names[0],
  }));
  const selected = value ? (brandOptions.find(o => o.value === value) || null) : null;
  const formatOptionLabel = (option) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <img src={option.value} style={{ height: '20px', width: '32px', objectFit: 'contain', flexShrink: 0 }} alt='' />
      <span>{option.label}</span>
    </div>
  );
  return (
    <Select
      options={brandOptions}
      value={selected}
      onChange={opt => onChange(opt ? opt.value : '')}
      formatOptionLabel={formatOptionLabel}
      placeholder='— brand —'
      isClearable
      menuPortalTarget={document.body}
      styles={{
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        control: (base) => ({
          ...base,
          background: 'transparent',
          border: 'none',
          borderBottom: '1px solid #aaa',
          borderRadius: 0,
          boxShadow: 'none',
          minHeight: 'unset',
          fontFamily: 'Verdana',
          fontSize: '0.85em',
          cursor: 'pointer',
          paddingLeft: 0,
        }),
        valueContainer: base => ({ ...base, padding: '0 4px 0 0' }),
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: base => ({ ...base, padding: '0 4px' }),
        clearIndicator: base => ({ ...base, padding: '0 4px' }),
        option: (base, state) => ({
          ...base,
          fontFamily: 'Verdana',
          fontSize: '0.85em',
          background: state.isFocused ? '#e8f0fe' : '#fff',
          color: '#222',
          cursor: 'pointer',
        }),
        menu: base => ({ ...base, zIndex: 9999 }),
      }}
    />
  );
};

export default BrandSelect;
